module.exports = __webpack_public_path__ + "logo-small-email-d933a21b89abd57a4da5a9b749704291.png";